// extracted by mini-css-extract-plugin
export var wrap = "layout-module--wrap--3wwNN";
export var loading = "layout-module--loading--O3Tkv";
export var loadingText = "layout-module--loadingText--1aKH5";
export var startButton = "layout-module--startButton--2P3fp";
export var fadeOut = "layout-module--fadeOut--dHKAb";
export var fadeIn = "layout-module--fadeIn--2bUro";
export var isScrollLocked = "layout-module--is-scrollLocked--1u1P8";
export var pagewrap = "layout-module--pagewrap--3U31v";